// bluaIQ — TASK-WEB-8/11/13: owner-only access lock for the takeoff read-only display.
//
// AUTHORITY: owner designation `exposure-access-owner-only` (evidence_class
// user_truth, designated by Maria 2026-07-08), recorded verbatim in the TAKEOFF
// repo artifact exposure_gate_designations_20260708_001 (commit 10aa3d9):
// "access to the takeoff module stays owner-only; nothing public or announced".
// A future designation may widen access (reversible per the artifact).
//
// TASK-WEB-13 (post-closeout backlog item 1, authorized by the Codex closeout
// PASS): the gate now reads Clerk publicMetadata — `takeoffOwner === true` —
// instead of an email allowlist. publicMetadata is writable ONLY server-side
// (Clerk secret key), so a user can never grant themselves access, and NO owner
// email ships in the public JS bundle anymore (the previous allowlist exposed
// both owner addresses to anyone reading the bundle). The flag was set on the
// owner's production Clerk user via a one-shot API call — see the TASK-WEB-13
// report for the documented command.
//
// This gate composes ON TOP of the existing dev-gate (clientFlags.ts) — BOTH
// must pass. No identity (Clerk not configured / signed out) is always DENIED.

/** The Clerk publicMetadata key that marks the owner's account. */
export const TAKEOFF_OWNER_METADATA_KEY = 'takeoffOwner'

/** True only when the signed-in user's publicMetadata carries
 *  `takeoffOwner: true` (strict boolean — strings/truthy values do not pass).
 *  null/undefined/no-identity is always false. */
export function isTakeoffOwnerAccount(publicMetadata: Record<string, unknown> | null | undefined): boolean {
  if (!publicMetadata || typeof publicMetadata !== 'object') return false
  return publicMetadata[TAKEOFF_OWNER_METADATA_KEY] === true
}
